//获取设备列表
function getList(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-device-list</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<is-hs-device-accept>1</is-hs-device-accept>' +
        '<manual-accept-device-share>1</manual-accept-device-share>' + //是否手动接受设备分享，0：自动接收，1：手动接受
        '<accept-sub-share>1</accept-sub-share>' +
        // '<filter>base</filter>' +
        '<order></order>' +
        '<count></count>' +
        '<page></page>' +
        '<owner></owner>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//获取设备状态和ip
function getDevStateList(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-dev-state</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<devid-list>' + obj.list + '</devid-list>' +
        // '<authid>' + obj.server + '</authid>' +
        '</content>' +
        '</envelope>';
    return xml;
};
var listObj = {
    id: '',
    name: '',
    type: '',
    ip: '',
    online: false,
    status: false,
    shareState: 0,
    share: false,
    shareStatus: false,
    isShare: 0,
    user: '',
    isHs: 0,
    weekdays: 0,
    periods: 0,
    accountID: 0,
    change: false,
    access: false,
    del: false,
    shareNum: '',
    channel: 1,
    password: ''
};

function logout(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>logout</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content></content>' +
        '</envelope>';
    return xml;
};
//获得某设备所有已分享好友
function getShare(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-friends-share-to</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//获取所有设备分享的好友
function deviceAllShare(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-all-devices-share-to</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<is-hs-device-accept>1</is-hs-device-accept>' + //app是否接受华师设备，0：只接受自研云设备，1：同时接受华师设备和自研云设备
        '<accept-sub-share>1</accept-sub-share>' +
        '</content>' +
        '</envelope>';
    return xml;
};

function delDevice(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>device-unbind</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</content>' +
        '</envelope>';
    return xml;
};
var result = {
    getList: getList,
    listObj: listObj,
    getDevStateList: getDevStateList,
    logout: logout,
    getShare: getShare,
    deviceAllShare: deviceAllShare,
    delDevice: delDevice
};
export default result;


// WEBPACK FOOTER //
// ./src/assets/js/cloud.js